import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import moment from 'moment';
import PropertyAttribute from '../PropertyAttribute/PropertyAttribute';
import {addressFormatting, amountFormatting} from '../../lib/formatting';
import styles from './PropertyCard.scss';

function PriceDisplay(props) {
  let returnEl = null;
  if (props.property) {
    if (props.property.category == 'Property' && _get(props.property, 'guesstimate.priceText') && props.view == 'Off-Market') {
      returnEl = <div className="text-right">Estimated {props.property.guesstimate.fromText} - {props.property.guesstimate.toText}</div>
    }
    else if (props.property.category == 'Property' && _get(props.property, 'lastSale.salePrice') && props.view == 'Recently Sold') {
      let lsDate = null;
      if (_get(props.property, 'lastSale.eventDate') && props.property.lastSale.eventDate != '') {
        lsDate = <div className="text-right smText">Sold {moment(props.property.lastSale.eventDate).format('MMM YYYY')}</div>;
      }
      let lsPrice = null;
      if (_get(props.property, 'lastSale.salePrice') && props.property.lastSale.salePrice != '' && props.property.lastSale.salePrice != 0) {
        lsPrice = <div className="text-right">{amountFormatting(props.property.lastSale.salePrice)}</div>
      }
      returnEl = <div>{lsDate}{lsPrice}</div>;
    }
  }
  return returnEl;
}

function PropertyListItem(props) {
  return (
    <div className={'mb-1'}>
      <div className="w-100">
        <div className="d-flex justify-content-between">
          <div className="font-weight-bold">{addressFormatting(props.property.address)}</div>
          {
            props.property.category == 'SaleListing' || props.property.category == 'RentalListing' ?
              props.property.listing.showPrice ?
                <div className="text-right">{props.property.listing.displayPrice}</div>
                : null
              : props.property.category == 'Property' ?
                <PriceDisplay {...props} />
                : null
          }
        </div>
        <div className={"smText d-flex mb-2 " + styles.propertyAttributes}>
          {props.property.beds ? <PropertyAttribute type='beds' value={props.property.beds} /> : null}
          {props.property.baths ? <PropertyAttribute type='baths' value={props.property.baths} /> : null}
          {props.property.carSpaces ? <PropertyAttribute type='carSpaces' value={props.property.carSpaces} /> : null}
        </div>
      </div>
    </div>
  );
}

PropertyListItem.protoTypes = {
  property: PropTypes.object.isRequired,
  view: PropTypes.string,
};
PropertyListItem.defaultProps = {
  view: 'Off-Market',
};

export default PropertyListItem;
